module.exports = __webpack_public_path__ + "static/img/dilemma04.ac911e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dilemma04.png
// module id = Pll1
// module chunks = 34